export default __webpack_public_path__ + "static/media/Astro_Mars_White.ecdfdf3b.png";